import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../body_root/Home_header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import Cookies from "js-cookie";
export default function Error_page() {
    const navigate = useNavigate();
    const [islogin, setislogin] = useState(true);
    const handleBackHome = () => {
        navigate('/');
    };

    useEffect(() => {
        const guid = Cookies.get('guid');
        if (guid) {
            setislogin(true);
        } else {
            setislogin(false); // Optional: explicitly handle false case
        }
    }, []);

    return (
        <>
          
            <div className='app_header_height'></div>
            <div className="container_roots">
                <div className="container_size">
                    <h1 style={styles.title}>404 - Page Not Found</h1>
                    <p style={styles.message}>This URL is not valid or the page does not exist.</p>
                    <p style={styles.subtext}>
                        Please check the web address for typos or use the button below to return to the homepage.
                    </p>
                    {islogin ? (
                        <div className='button-ui' onClick={() => navigate('/dashboard')}>Go to Dashboard</div>
                    ) : (
                        <div className='button-ui' onClick={() => navigate('/')}>Go to Home</div>
                    )}

                </div>
            </div>
           
            
        </>
    );

}

const styles = {

    title: {
        fontSize: '36px',
        color: '#e74c3c',
    },
    message: {
        fontSize: '20px',
        margin: '20px 0',
    },
    subtext: {
        fontSize: '16px',
        color: '#555',
        marginBottom: '30px',
    },
    button: {
        backgroundColor: '#3498db',
        color: '#fff',
        padding: '12px 24px',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '16px',
    },

};
